import { isDebug, showErrorLog, showLog, showSuccLog } from "./logHelper";
// 【阿维塔科技】服务号 appId(默认为此公众号)
const WX_APPID = "wx36358e9a613b4d06";
const openTagList = ["wx-open-launch-app", "wx-open-launch-weapp"];
const jsApiList = ["updateAppMessageShareData", "updateTimelineShareData", "onMenuShareTimeline（即将废弃）", "onMenuShareAppMessage（即将废弃）", "onMenuShareQQ（即将废弃）", "onMenuShareWeibo", "onMenuShareQZone", "startRecord", "stopRecord", "onVoiceRecordEnd", "playVoice", "pauseVoice", "stopVoice", "onVoicePlayEnd", "uploadVoice", "downloadVoice", "chooseImage", "previewImage", "uploadImage", "downloadImage", "translateVoice", "getNetworkType", "openLocation", "getLocation", "hideOptionMenu", "showOptionMenu", "hideMenuItems", "showMenuItems", "hideAllNonBaseMenuItem", "showAllNonBaseMenuItem", "closeWindow", "scanQRCode", "chooseWXPay", "openProductSpecificView", "addCard", "chooseCard", "openCard"];
// wx.ready(function () {
//   // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，
//   // 所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。
//   // 对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
// });
// wx.error(function (res) {
//   // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，
//   // 也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
// });
/**
 * 微信 sdk 验签
 * 项目中需引用脚本:
 * <script src="//static.avatr.com/scripts/jweixin-1.6.0.js"></script>
 * 目前仅stg/prod环境可以正常工作, 平时可以使用公众号测试
 */
export const wechatReady = (ready, appId) => {
  if (!wx) {
    return;
  }
  const url = window.location.href.replace(window.location.hash, "");
  let result = {};
  //   isDebug() && showSuccLog("验签成功", result);
  //   isDebug() && showErrorLog("验签失败", "timeout啦");
  fetch(`/api/auth/getOfficialSignature?url=${url}`, {
    method: "get",
    headers: {
      "Content-Type": "application/json"
    }
  }).then(response => response.json()).then(data => {
    isDebug() && showSuccLog("验签成功", data);
    result = data.result;
    wx.config({
      debug: false,
      appId: appId || WX_APPID,
      timestamp: result === null || result === void 0 ? void 0 : result.timestamp,
      nonceStr: result === null || result === void 0 ? void 0 : result.noncestr,
      signature: result === null || result === void 0 ? void 0 : result.signature,
      jsApiList,
      openTagList
    });
    if (ready) {
      wx.ready(ready);
      wx.error(ready);
    }
  }).catch(error => {
    isDebug() && showErrorLog("验签失败", error === null || error === void 0 ? void 0 : error.message);
  }).finally(() => {
    //
  });
};
/**
 * 获取微信地理位置
 * @returns Promise<{
 * 	longitude?: number 经度
 *  latitude?: number  维度
 * }>
 */
export const getLocation = appId => {
  return new Promise((resolve, reject) => {
    wechatReady(() => {
      wx.getLocation({
        type: "gcj02",
        success: function (res) {
          isDebug() && showSuccLog("获取微信地理位置成功", res);
          resolve(res);
        },
        fail: function (err) {
          isDebug() && showErrorLog("获取微信地理位置失败", err);
          reject(err);
        },
        cancel: function (msg) {
          isDebug() && showLog("取消获取微信地理位置", msg);
          reject(msg);
        }
      });
    }, appId);
  });
};
/**
 * 使用微信内置地图查看位置
 * @param latitude 纬度，范围为-90~90，负数表示南纬
 * @param longitude 经度，范围为-180~180，负数表示西经
 * @param name 位置名
 * @param address 地址的详细说明
 */
export const openLocation = (prams, appId) => {
  wechatReady(() => {
    wx.openLocation(Object.assign({}, prams));
  }, appId);
};
/**
 * 获取微信扫码信息
 * @param succCallback 成功回调函数
 * @param failCallback 失败回调函数
 */
export const scanQRCode = (func, appId) => {
  wechatReady(() => {
    wx.scanQRCode({
      success: res => {
        isDebug() && showSuccLog("微信扫码成功", res);
        func.succCallback && func.succCallback(res);
      },
      fail: err => {
        isDebug() && showErrorLog("微信扫码失败", err);
        func.failCallback && func.failCallback(err);
      }
    }, appId);
  });
};
/**
 * 同时设置分享好友及朋友圈信息
 * @param shareDate :  {
 * 	title: string;
 *	desc: string;
 *	link: string;
 *	imgUrl: string;
 * }
 */
export const setShareInfo = (shareDate, appId) => {
  wechatReady(() => {
    wx === null || wx === void 0 ? void 0 : wx.updateAppMessageShareData(Object.assign(Object.assign({}, shareDate), {
      success: function (res) {
        isDebug() && showSuccLog("微信分享好友成功", res);
      },
      fail: function (err) {
        isDebug() && showErrorLog("微信分享好友失败", err);
      }
    }));
    wx === null || wx === void 0 ? void 0 : wx.updateTimelineShareData(Object.assign(Object.assign({}, shareDate), {
      success: function (res) {
        isDebug() && showSuccLog("微信分享朋友圈成功", res);
      },
      fail: function (err) {
        isDebug() && showErrorLog("微信分享朋友圈失败", err);
      }
    }));
  }, appId);
};
/**
 * 设置分享好友信息
 * @param shareDate :  {
 * 	title: string;
 *	desc: string;
 *	link: string;
 *	imgUrl: string;
 * }
 */
export const setShareToFriend = (shareDate, appId) => {
  wechatReady(() => {
    wx === null || wx === void 0 ? void 0 : wx.updateAppMessageShareData(Object.assign(Object.assign({}, shareDate), {
      success: function (res) {
        isDebug() && showSuccLog("微信分享好友成功", res);
      },
      fail: function (err) {
        isDebug() && showErrorLog("微信分享好友失败", err);
      }
    }));
  }, appId);
};
/**
 * 设置分享朋友圈信息
 * @param shareDate :  {
 * 	title: string;
 *	link: string;
 *	imgUrl: string;
 * }
 */
export const setShareToTimeline = (shareDate, appId) => {
  wechatReady(() => {
    wx === null || wx === void 0 ? void 0 : wx.updateTimelineShareData(Object.assign(Object.assign({}, shareDate), {
      success: function (res) {
        isDebug() && showSuccLog("微信分享朋友圈成功", res);
      },
      fail: function (err) {
        isDebug() && showErrorLog("微信分享朋友圈失败", err);
      }
    }));
  }, appId);
};